import { createContext, type ReactNode } from "react";
import type { ToastOptions } from "./Toast";

export type ToastFn = (message: ReactNode, opts?: ToastOptions) => void;
export const ToastCtx = createContext<ToastFn | null>(null);
